import React from 'react';
import s from './CustomGreenCheckbox.module.css';

type Props = {
	checked: boolean;
	handleChange: (id: string) => void;
	id: string;
	label?: string;
};
const EasyGreenCheckBox: React.FC<Props> = ({
	handleChange,
	checked,
	id,
	label,
}) => {
	return (
		<div className={s.checkBoxContainer}>
			<input
				className={s.checkboxInput}
				checked={checked}
				onChange={() => handleChange(id)}
				id={id}
				type="checkbox"
			/>
			<label htmlFor={id}>{label}</label>
		</div>
	);
};

export default EasyGreenCheckBox;
